/**
 * @type {Object} options 本次請求配置；
 * @type {Boolean} options.errorDialog - 本次是否顯示錯誤提示（這個變數只針對data.detail顯示）
 * @type {Boolean} options.secure - 沒用到
 * @type {Boolean} options.baseURL - 是否為基礎環境
 * @type {Boolean} options.repeatRequestCancel - 開啟禁止重複打相同api'
 * @type {Boolean} options.responseType - response文本型態
 * @type {Boolean} options.closeAlert - 關閉錯誤提示(所有錯誤訊息)(預設是notify)
 * @type {Boolean} options.formData - 檔案格式
 */
const requestOptions = {
    errorDialog: true,
    secure: false,
    baseURL: true,
    repeatRequestCancel: false,
    responseType: 'json',
    closeAlert: false,
    formData: false,
};
Object.freeze(requestOptions);
export { requestOptions };
